import {
  amber,
  amberDark,
  blue,
  blueDark,
  bronze,
  bronzeDark,
  brown,
  brownDark,
  crimson,
  crimsonDark,
  cyan,
  cyanDark,
  gold,
  goldDark,
  grass,
  grassDark,
  gray,
  grayDark,
  green,
  greenDark,
  indigo,
  indigoDark,
  iris,
  irisDark,
  jade,
  jadeDark,
  lime,
  limeDark,
  mauve,
  mauveDark,
  mint,
  mintDark,
  olive,
  oliveDark,
  orange,
  orangeDark,
  pink,
  pinkDark,
  plum,
  plumDark,
  purple,
  purpleDark,
  red,
  redDark,
  ruby,
  rubyDark,
  sage,
  sageDark,
  sand,
  sandDark,
  sky,
  skyDark,
  slate,
  slateDark,
  teal,
  tealDark,
  tomato,
  tomatoDark,
  violet,
  violetDark,
  yellow,
  yellowDark,
} from '@radix-ui/colors';

declare module '@unity/cloud-ui/styles' {
  interface PaletteOptions {
    icons: {
      gray: string;
      mauve: string;
      slate: string;
      sage: string;
      olive: string;
      sand: string;
      tomato: string;
      red: string;
      ruby: string;
      crimson: string;
      pink: string;
      plum: string;
      purple: string;
      violet: string;
      iris: string;
      indigo: string;
      blue: string;
      cyan: string;
      teal: string;
      jade: string;
      green: string;
      grass: string;
      brown: string;
      bronze: string;
      gold: string;
      sky: string;
      mint: string;
      lime: string;
      yellow: string;
      amber: string;
      orange: string;
    };
  }
  interface Palette {
    icons: {
      gray: string;
      mauve: string;
      slate: string;
      sage: string;
      olive: string;
      sand: string;
      tomato: string;
      red: string;
      ruby: string;
      crimson: string;
      pink: string;
      plum: string;
      purple: string;
      violet: string;
      iris: string;
      indigo: string;
      blue: string;
      cyan: string;
      teal: string;
      jade: string;
      green: string;
      grass: string;
      brown: string;
      bronze: string;
      gold: string;
      sky: string;
      mint: string;
      lime: string;
      yellow: string;
      amber: string;
      orange: string;
    };
  }
}

export const customPalette = {
  light: {
    icons: {
      gray: gray.gray11,
      mauve: mauve.mauve11,
      slate: slate.slate11,
      sage: sage.sage11,
      olive: olive.olive11,
      sand: sand.sand11,
      tomato: tomato.tomato11,
      red: red.red11,
      ruby: ruby.ruby11,
      crimson: crimson.crimson11,
      pink: pink.pink11,
      plum: plum.plum11,
      purple: purple.purple11,
      violet: violet.violet11,
      iris: iris.iris11,
      indigo: indigo.indigo11,
      blue: blue.blue11,
      cyan: cyan.cyan11,
      teal: teal.teal11,
      jade: jade.jade11,
      green: green.green11,
      grass: grass.grass11,
      brown: brown.brown11,
      bronze: bronze.bronze11,
      gold: gold.gold11,
      sky: sky.sky11,
      mint: mint.mint11,
      lime: lime.lime11,
      yellow: yellow.yellow11,
      amber: amber.amber11,
      orange: orange.orange11,
    },
  },
  dark: {
    icons: {
      gray: grayDark.gray11,
      mauve: mauveDark.mauve11,
      slate: slateDark.slate11,
      sage: sageDark.sage11,
      olive: oliveDark.olive11,
      sand: sandDark.sand11,
      tomato: tomatoDark.tomato11,
      red: redDark.red11,
      ruby: rubyDark.ruby11,
      crimson: crimsonDark.crimson11,
      pink: pinkDark.pink11,
      plum: plumDark.plum11,
      purple: purpleDark.purple11,
      violet: violetDark.violet11,
      iris: irisDark.iris11,
      indigo: indigoDark.indigo11,
      blue: blueDark.blue11,
      cyan: cyanDark.cyan11,
      teal: tealDark.teal11,
      jade: jadeDark.jade11,
      green: greenDark.green11,
      grass: grassDark.grass11,
      brown: brownDark.brown11,
      bronze: bronzeDark.bronze11,
      gold: goldDark.gold11,
      sky: skyDark.sky11,
      mint: mintDark.mint11,
      lime: limeDark.lime11,
      yellow: yellowDark.yellow11,
      amber: amberDark.amber11,
      orange: orangeDark.orange11,
    },
  },
};
